import React from 'react';
import { 
  Box, 
  Flex, 
  VStack, 
  Text, 
  Icon
} from '@chakra-ui/react';
import { FaCheck, FaPlus } from 'react-icons/fa';

interface AddPinButtonProps {
  onClick: () => void;
  isPinMode: boolean;
  type?: 'theatre' | 'game';
  color?: string;
}

const AddPinButton: React.FC<AddPinButtonProps> = ({ 
  onClick, 
  isPinMode, 
  type = 'theatre',
  color = 'blue'
}) => {
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation(); // Stop event bubbling
    onClick();
  };

  return (
    <VStack
      spacing={3}
      align="center"
      transition="all 0.3s"
      _hover={{ transform: 'translateY(-5px) scale(1.05)' }}
      role="group"
      position="relative"
      cursor="pointer"
      onClick={handleClick}
      className="add-pin-button"
    >
      <Flex
        w="150px"
        h="150px"
        align="center"
        justify="center"
        borderRadius="24px"
        bg="rgba(0, 0, 0, 0.6)"
        color={`${color}.400`}
        backdropFilter="blur(10px)"
        borderWidth="1px"
        borderColor="rgba(255, 255, 255, 0.1)"
        boxShadow="0 8px 20px rgba(0, 0, 0, 0.4)"
        position="relative"
        overflow="hidden"
        transition="all 0.3s ease"
        _hover={{ 
          color: `${color}.300`,
          borderColor: "rgba(255, 255, 255, 0.2)",
        }}
        _after={{
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: `radial-gradient(circle at center, rgba(37, 99, 235, 0.1) 0%, rgba(0, 0, 0, 0) 70%)`,
          opacity: 0.6,
          zIndex: 0
        }}
      >
        <Box position="relative" zIndex={1}>
          <Icon as={isPinMode ? FaCheck : FaPlus} boxSize={6} />
        </Box>
      </Flex>
      
      <Text 
        fontSize="sm" 
        color="gray.300"
        textAlign="center"
        noOfLines={2}
        width="100%"
        wordBreak="break-word"
        maxWidth="150px"
      >
        {isPinMode ? "Done" : `Add ${type === 'theatre' ? 'App' : 'Game'}`}
      </Text>
    </VStack>
  );
};

export default AddPinButton; 